export const DEFAULT_CURRENCY_TICKER = 'TNB';
export const MAX_MINT_AMOUNT = 1_000_000_000;
